import React from "react";
import { Action, Dispatch } from "redux";
import {
  TableHeaderProps,
  TableProps,
  TableDataRowProps
} from "../../../../Common/UI/Index";
import { OutputConfigSlice } from "../../redux";
import { Menus } from "../../OutputConfigDialog/DialogNavTabs/Types";
import {
  CONFIGURED,
  DESCRIPTION_BY_STATUS, NOT_CONFIGURED,
} from "./Constants";
import Search from "~icons/ic/outline-search";
import "./Styles.scss";

export interface FinalListItem {
  /**
   * Config id from api response
   */
  outputElementGuid?: string;
  /**
   * Status from api response
   */
  status: string;
  /**
   * Tag name from api response
   */
  tag?: string;
}

/**
 * To render the action column icons
 * @returns the icons
 * NOTE: Type any is used because UI Table accepts only strings as values
 * but we need icons in the table row
 */
const getActionColumn = (statusType: string, configMapId: string, dispatch: Dispatch<Action>): any => {
  /**
   * Action when search is clicked
   */
  const onHandleSearch = (): void => {
    dispatch(OutputConfigSlice.actions.setFocusConfigId(configMapId));
    dispatch(OutputConfigSlice.actions.setShowBandings(true));
    dispatch(OutputConfigSlice.actions.selectTab(Menus[2]));
  };

  return (
    (statusType === NOT_CONFIGURED && configMapId !== "") ?
      <Search
        className="final-output-search"
        title="search"
        onClick={onHandleSearch}
      />
      : "");
};

/**
 * Method to handle the styling for status (For missing and extra its not configured)
 * @param statusType Type of the status
 * @returns JSX.Element
 */
const getStatus = (statusType: string): JSX.Element => {
  const validatedStatus = (statusType === CONFIGURED) ? CONFIGURED : "Not-Configured";
  const formattedStatus = validatedStatus.replace(/-/g, " ");
  return <div className={`ebt-config-status__${validatedStatus}`}>{formattedStatus}</div>;
};

/**
 * To bind the table data
 * @param data response data
 * @returns the formatted table row data
 */
const buildDataRow = (data: string, dispatch: Dispatch<Action>): TableDataRowProps[] => {
  const response = JSON.parse(data);
  let outputData: TableDataRowProps[] = [];
  const inputData = response;
  outputData = inputData.map((item: FinalListItem) => {
    const statusUppercase = item.status.toUpperCase();
    const output: TableDataRowProps = {
      row: [
        {
          value: item.tag || "-",
          propertyName: "name"
        },
        {
          value: DESCRIPTION_BY_STATUS[statusUppercase] || "-",
          propertyName: "descriptionOfStatus"
        },
        {
          value: getStatus(item.status),
          propertyName: "status"
        },
        {
          value: getActionColumn(item.status, item.outputElementGuid || "", dispatch),
          propertyName: "actions"
        }
      ]
    };
    return output;
  });

  return outputData;
};

/**
 * To populate the table data
 * @param data response data
 * @returns the formatted data to bind the table
 */
export const PopulateTable = (data: string, dispatch: Dispatch<Action>): TableProps => {
  let table: TableProps = {} as TableProps;
  const tableHeader: TableHeaderProps[] = [
    {
      title: "OutputConfig.FinalOutputTable.Name",
      propertyName: "name",
      width: "45%"
    },
    {
      title: "OutputConfig.FinalOutputTable.DescriptionOfStatus",
      propertyName: "descriptionOfStatus",
      width: "40%"
    },
    {
      title: "OutputConfig.FinalOutputTable.Status",
      propertyName: "status",
      width: "10%"
    },
    {
      title: "OutputConfig.FinalOutputTable.Action",
      propertyName: "actions",
      width: "5%"
    }
  ];

  table = {
    headerRow: tableHeader,
    dataRow: buildDataRow(data, dispatch)
  };

  return table;
};
